export enum BettingMode {
    singleDraw = "singleDraw",
    multiDraw = "multiDraw",
    standingOrder = "standingOrder",
}
